import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Video } from '../../../models/video'
import { ResourcesCssService } from '../../resources/resources-css.service'

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {

  @Input() video: Video
  loaded = false

  constructor(public resourcesCssService: ResourcesCssService) { }

  ngOnInit() {
  }

  play() {
    window.open(this.video.url, '_blank')
  }

  load() {
    this.loaded = true
  }
}
